import { FirebaseApi } from "./FirebaseApi";

class Apis {
  private readonly createRegistrationApi: string;
  private readonly updateRegistrationApi: string;
  private readonly deleteRegistrationApi: string;
  private readonly deleteAllRegistrationApi: string;
  private readonly updateWaitlistEntryApi: string;
  private readonly deleteWaitlistEntryApi: string;
  private readonly transferWaitlistEntryApi: string;

  constructor(
    createRegistrationApi?: string,
    updateRegistrationApi?: string,
    deleteRegistrationApi?: string,
    deleteAllRegistrationApi?: string,
    updateWaitlistEntryApi?: string,
    deleteWaitlistEntryApi?: string,
    transferWaitlistEntryApi?: string
  ) {
    this.createRegistrationApi = Apis.throwIfFalsy(createRegistrationApi);
    this.updateRegistrationApi = Apis.throwIfFalsy(updateRegistrationApi);
    this.deleteRegistrationApi = Apis.throwIfFalsy(deleteRegistrationApi);
    this.deleteAllRegistrationApi = Apis.throwIfFalsy(deleteAllRegistrationApi);
    this.updateWaitlistEntryApi = Apis.throwIfFalsy(updateWaitlistEntryApi);
    this.deleteWaitlistEntryApi = Apis.throwIfFalsy(deleteWaitlistEntryApi);
    this.transferWaitlistEntryApi = Apis.throwIfFalsy(transferWaitlistEntryApi);
  }

  public getFirebaseApi(): FirebaseApi {
    return new FirebaseApi(
      this.createRegistrationApi,
      this.updateRegistrationApi,
      this.deleteRegistrationApi,
      this.deleteAllRegistrationApi,
      this.updateWaitlistEntryApi,
      this.deleteWaitlistEntryApi,
      this.transferWaitlistEntryApi
    );
  }

  private static throwIfFalsy(value?: string): string {
    if (!value) {
      throw new Error("Registration API is not defined");
    }
    return value;
  }
}

export default new Apis(
  import.meta.env.VITE_POST_REGISTRATION_API,
  import.meta.env.VITE_PUT_REGISTRATION_API,
  import.meta.env.VITE_DELETE_REGISTRATION_API,
  import.meta.env.VITE_DELETE_ALL_REGISTRATION_API,
  import.meta.env.VITE_PUT_WAITLIST_ENTRY_API,
  import.meta.env.VITE_DELETE_WAITLIST_ENTRY_API,
  import.meta.env.VITE_TRANSFER_WAITLIST_ENTRY_API
);
